import createAction from 'redux-actions/es/createAction';

export const getCountryByIpRequest = createAction('GET_COUNTRY_BY_IP_REQUEST');
export const getCountryByIpSuccess = createAction('GET_COUNTRY_BY_IP_SUCCESS');
export const getCountryByIpFail = createAction('GET_COUNTRY_BY_IP_FAIL');
